/*
  Rent with Reve - rental date prompt + sticky add-to-bag guard

  Two problems this solves on Supercycle product pages:

  1. When the rental method is selected and no dates are chosen, Supercycle
     disables the main ADD TO BAG button with no explanation. A disabled
     button emits no click events, so the button is given pointer-events:none
     (see injectStyles below) and the click is caught on its wrapper instead.

  2. The sticky add-to-bag bar submits its own form, which never carries
     Supercycle's selling_plan or _cycle / date properties - even once dates
     are chosen. Left alone it creates cart lines with no rental attached.
     Its submit is intercepted and forwarded to the real product form.
*/
(function () {
  'use strict';

  var SC_ROOT = '.supercycle-methods';
  var CAL = '.supercycle-method--calendar';
  var SELECTED = 'supercycle-method--selected';
  var UNAVAILABLE = 'supercycle-method--unavailable';
  var DATE_INPUT = '.supercycle-duration-picker-input__input';
  var DATE_FIELD = '.supercycle-duration-picker-input';
  var MAIN_FORM = 'form.main-product-form';
  var STICKY_FORM = 'form.sticky-atc-form';
  var BTN_WRAP = '.f-product-form__buttons';
  var ADD_BTN = '.f-product-form__submit';
  var HINT_CLASS = 'reve-date-hint';
  var ATTENTION_CLASS = 'reve-dates-attention';
  var HINT_TEXT = 'Select your rental dates to continue';

  // Styles live here so the whole feature is one file. The hint element is
  // only created after this runs, so there is nothing to flash.
  function injectStyles() {
    if (document.getElementById('reve-rental-date-prompt-css')) return;
    var css = document.createElement('style');
    css.id = 'reve-rental-date-prompt-css';
    css.textContent = [
      /* A disabled button fires no click events, so let the click fall
         through to .f-product-form__buttons, which listens for it. */
      'form.main-product-form .f-product-form__submit[disabled]{pointer-events:none;}',
      '.reve-date-hint{display:none;margin:0 0 1rem;font-size:1.3rem;line-height:1.4;color:#878078;}',
      '.reve-date-hint.is-visible{display:block;}',
      '.reve-date-hint.is-attention{color:#83545f;}',
      'html.reve-dates-attention .supercycle-duration-picker-input{box-shadow:0 0 0 1px #af838e;}'
    ].join('');
    (document.head || document.documentElement).appendChild(css);
  }

  function hasSupercycle() {
    return !!document.querySelector(SC_ROOT);
  }

  // True when the rental option is the selected one and a date is still blank.
  function needsDates() {
    var cal = document.querySelector(CAL);
    if (!cal) return false;
    if (!cal.classList.contains(SELECTED)) return false;
    if (cal.classList.contains(UNAVAILABLE)) return false;
    var inputs = cal.querySelectorAll(DATE_INPUT);
    if (!inputs.length) return false;
    for (var i = 0; i < inputs.length; i++) {
      if (!String(inputs[i].value).trim()) return true;
    }
    return false;
  }

  function mainButtonWrap() {
    var form = document.querySelector(MAIN_FORM);
    return form ? form.querySelector(BTN_WRAP) : null;
  }

  function getHint() {
    var wrap = mainButtonWrap();
    if (!wrap) return null;
    var hint = wrap.querySelector('.' + HINT_CLASS);
    if (!hint) {
      hint = document.createElement('p');
      hint.className = HINT_CLASS;
      hint.setAttribute('aria-live', 'polite');
      hint.textContent = HINT_TEXT;
      wrap.insertBefore(hint, wrap.firstChild);
    }
    return hint;
  }

  var pending = null;

  function sync() {
    pending = null;
    if (!hasSupercycle()) return;
    var hint = getHint();
    if (!hint) return;
    var need = needsDates();
    if (hint.classList.contains('is-visible') !== need) {
      hint.classList.toggle('is-visible', need);
    }
    if (!need) {
      hint.classList.remove('is-attention');
      document.documentElement.classList.remove(ATTENTION_CLASS);
    }
    // Keep the sticky bar honest: it should not look clickable while the
    // rental is incomplete.
    var sticky = document.querySelector(STICKY_FORM);
    if (sticky) {
      var sBtn = sticky.querySelector(ADD_BTN);
      if (sBtn && sBtn.disabled !== need) sBtn.disabled = need;
    }
  }

  function schedule() {
    if (pending) return;
    pending = setTimeout(sync, 80);
  }

  // Draw the shopper to the date fields.
  function promptForDates() {
    var hint = getHint();
    if (hint) hint.classList.add('is-visible', 'is-attention');
    document.documentElement.classList.add(ATTENTION_CLASS);
    var cal = document.querySelector(CAL);
    if (!cal) return;
    var inputs = cal.querySelectorAll(DATE_INPUT);
    var first = null;
    for (var i = 0; i < inputs.length; i++) {
      if (!String(inputs[i].value).trim()) { first = inputs[i]; break; }
    }
    if (!first) return;
    var field = first.closest(DATE_FIELD) || first;
    if (field.scrollIntoView) field.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () {
      try { first.focus({ preventScroll: true }); } catch (e) {}
    }, 400);
  }

  // 1. Click landing on the disabled main button.
  document.addEventListener('click', function (evt) {
    if (!hasSupercycle()) return;
    var target = evt.target;
    if (!target || !target.closest) return;
    var wrap = target.closest(BTN_WRAP);
    if (!wrap || wrap !== mainButtonWrap()) return;
    var btn = wrap.querySelector(ADD_BTN);
    if (!btn || !btn.disabled) return;
    var rect = btn.getBoundingClientRect();
    if (evt.clientX < rect.left || evt.clientX > rect.right) return;
    if (evt.clientY < rect.top || evt.clientY > rect.bottom) return;
    if (!needsDates()) return;
    evt.preventDefault();
    promptForDates();
  }, true);

  // 2. Sticky bar submit - never let it post its own incomplete form.
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.matches || !form.matches(STICKY_FORM)) return;
    if (!hasSupercycle()) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    if (needsDates()) { promptForDates(); return; }
    var mainForm = document.querySelector(MAIN_FORM);
    if (!mainForm) return;
    var mainBtn = mainForm.querySelector(ADD_BTN);
    if (!mainBtn || mainBtn.disabled) { promptForDates(); return; }
    try {
      if (typeof mainForm.requestSubmit === 'function') mainForm.requestSubmit(mainBtn);
      else mainBtn.click();
    } catch (e) {}
  }, true);

  function watch() {
    var root = document.querySelector(SC_ROOT);
    if (!root) { setTimeout(watch, 500); return; }
    new MutationObserver(schedule).observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'value']
    });
    schedule();
  }

  function start() {
    injectStyles();
    watch();
    // Safety net: the theme re-renders the product form on variant change.
    setInterval(schedule, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
